/**
 * This file is a part of Amblique's projects.
 *
 * Copyright © Amblique - All Rights Reserved.
 *
 * Unauthorized copying of this file, via any medium is strictly prohibited.
 * Proprietary and confidential.
 */

import {useMemo} from 'react';
import {get} from 'lodash';

import useMultiSite from '@salesforce/retail-react-app/app/hooks/use-multi-site';

/**
 * @param {string|string[]} [path]         Optional property path to get the data from context
 * @param {any}             [defaultValue] The default value if preference doesn't exists
 *
 * @returns {any}
 */
export function useSitePreference(path = null, defaultValue) {
  const {site: {preferences = {}}} = useMultiSite();

  return useMemo(() => {
    return path ? get(preferences, path, defaultValue) : preferences;
  }, [preferences, path, defaultValue]);
}
